var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterTgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2545 48 48 37.2545 48 24C48 10.7455 37.2545 0 24 0C10.7455 0 0 10.7455 0 24C0 37.2545 10.7455 48 24 48ZM7.95055 22.7782C7.84721 22.8186 7.75835 22.8891 7.69536 22.9805C7.63238 23.0718 7.59815 23.1799 7.59709 23.2909C7.59709 23.5135 7.74327 23.7229 7.95055 23.8015L14.4676 26.1796L27.8945 19.248C27.9655 19.2151 28.0458 19.2079 28.1215 19.2279C28.1972 19.2478 28.2635 19.2935 28.3091 19.3571C28.3518 19.4225 28.3704 19.5008 28.3616 19.5785C28.3529 19.6561 28.3173 19.7283 28.2611 19.7825L19.224 27.888L29.3498 36.0415C29.496 36.1462 29.6924 36.1724 29.8604 36.1113C29.9441 36.0792 30.0188 36.0274 30.0781 35.9601C30.1374 35.8928 30.1795 35.8122 30.2007 35.7251L35.5636 13.1695C35.5858 13.0729 35.5817 12.9723 35.5518 12.8779C35.5219 12.7835 35.4672 12.6988 35.3935 12.6327C35.3185 12.568 35.2275 12.5246 35.1301 12.5069C35.0326 12.4892 34.9322 12.498 34.8393 12.5324L7.95055 22.7782Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTgIcon);
export default __webpack_public_path__ + "static/media/footerTgIcon.20fc9fb63d52f1a17f36a39a6454cb9a.svg";
export { ForwardRef as ReactComponent };